import React, { Fragment, useState, useEffect } from 'react';
import "./Header.css";
import { Avatar } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import { Link } from "react-router-dom";
import { db, auth } from "../firebase";
import ChatIcon from "@material-ui/icons/Chat";
import WarningRoundedIcon from "@material-ui/icons/WarningRounded";
import HelpOutlinedIcon from "@material-ui/icons/HelpOutlined";
import ExitToAppIcon from "@material-ui/icons/ExitToAppRounded"

function Header({ user }) {
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [users, setUsers] = useState([]);

    const handleLogout = (e) => {
        e.preventDefault();
        if (user) {
            auth.signOut();
        }
    }




    useEffect(() => {
        db.collection("userInfo").onSnapshot(snapshot => {
            setUsers(snapshot.docs.map((doc) => doc.data()))
        })

        if (users !== undefined) {
            const searchedUsers = users.filter(user => {
                return user.displayName.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1;
            }) 
            setFilteredUsers(searchedUsers);
        }
        // eslint-disable-next-line
    }, [searchTerm])

    const updateSearchResults = (e) => {
        setSearchTerm(e.target.value);
        document.getElementsByClassName("search__dropdown")[0].style.display = "block";
    }

        // If the user clicks on Search Icon, the search__dropdown must close.
    const closeSearchDropdown = () => {
        document.getElementsByClassName("search__dropdown")[0].style.display = "none";
    }

    if (user === undefined) {
        document.getElementsByClassName("header__right")[0].style.display = "none"
    }

    const dea = () => {
        alert("The search feature is under development for devices with width 768px or less. You can use this feature in desktop.")
    }

    return (
        <div className="header">
            <div className="header__left">
                <img src="/Images/TiTaniht-logo.png" alt="TiTaniht's logo" />
                <h3>TiTaniht</h3>
            </div>
            <div className="header__middle">
                <SearchIcon className="searchIcon" onClick={closeSearchDropdown} />
                <SearchIcon className="searchIcon__mobile" onClick={dea}/>
                <input type="text" placeholder="Search the users of TiTaniht" onChange={updateSearchResults} className="search__input" />
                <div className="search__dropdown">
                    <ul id="searchUserList">
                    {
                        users !== undefined && (
                            filteredUsers.map((user1) => (
                                <li>
                                    <Link className="profile__navigater" onClick={closeSearchDropdown} to={`/${user1?.displayName}/${user1?.uid}`}>
                                        <Avatar classname="searchUsers__avatar" src={user1.photoURL} />
                                        <h3 className="searchedUsers__name">{user1.displayName}</h3>
                                    </Link>
                                </li>
                            ))
                        )
                    }
                    </ul>
                </div>
            </div>
            <div className="header__right">
                <a className="navigate" href="https://instagram-clone-react-7d068.web.app">
                <div className="header_right_options first_option">
                    <ChatIcon style={{ color: "green" }} />
                    <p style={{ color: "green" }}>Chat</p>
                </div>
                </a>
                <a className="navigate" href="https://firestone-2ff13.web.app">
                <div className="header_right_options">
                    <WarningRoundedIcon style={{ color: "#1f62f2" }}/>
                    <p style={{ color: "#1f62f2" }}>Cov...</p>
                </div>
                </a>
                <Link className="navigate" to="/help"> 
                <div className="header_right_options">
                    <HelpOutlinedIcon style={{ color: "orange" }} />
                    <p style={{ color: "orange" }}>Help</p>
                </div>
                </Link>
                <div className="header_right_options" onClick={handleLogout}>
                    <ExitToAppIcon style={{ color: "red" }} />
                    <p style={{ color: "red" }} >Logout</p>
                </div>

                <Link className="profile__navigater" to={`/${user?.displayName}/${user?.uid}`}>
                {
                    <Fragment>
                        <Avatar src={user.photoURL} />
                        <h3 className="utftulb">{user.displayName}</h3>
                    </Fragment>
                }
                </Link>
            </div>
        </div>
    )
}

export default Header;